export const formatHolidayEndDate = (endDate: string): string => {
	const date = new Date(`${endDate}T12:00:00`)

	if (Number.isNaN(date.getTime())) {
		return endDate
	}

	return new Intl.DateTimeFormat('en-GB', {
		day: 'numeric',
		month: 'long',
	}).format(date)
}

export const formatHolidayDispatchDelay = (remainingDays: number): string => {
	const delay = Math.max(0, Math.round(remainingDays))

	return `Up to ${delay} ${delay === 1 ? 'day' : 'days'}`
}
